import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ExternalService } from 'src/app/shared/services/external.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-addcustomer',
  templateUrl: './addcustomer.component.html',
  styleUrl: './addcustomer.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class AddcustomerComponent implements OnInit {
  @ViewChild('DeleteModel', { static: true }) DeleteModel: ElementRef<any>
  @ViewChild('errorModal', { static: true }) errorModal: ElementRef<any>
  checkoutForm: FormGroup;



  constructor(private fb: UntypedFormBuilder, private externalService: ExternalService, private modalService: NgbModal, private toastrService: ToastrService,) {

    this.checkoutForm = this.fb.group({
      name: [null, [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
      // lastname: ['', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$')]],
      phone: [null, [Validators.required, Validators.pattern('[0-9]+')]],
      // email: ['', [Validators.required, Validators.email]],
      address: [null, [Validators.required, Validators.maxLength(150)]],
      // country: ['', Validators.required],
      // town: [null, Validators.required],
      city: [{ value: '', disabled: true }, Validators.required], // Initially disabled,
      state: ['', Validators.required],
      landmark: '',
      postalcode: [
        null,
        [
          Validators.required,
          Validators.pattern(/^[5-6][0-9]{5}$/) // Ensures it starts with 5 or 6 and has 6 digits
        ]
      ],
      iscurrentaddress: false


    })
    this.customerid = localStorage.getItem('customerid');
  }
  citiesByState: any = {
    'Tamil Nadu': ['Chennai', 'Coimbatore', 'Madurai', 'Ambattur', 'Avadi', 'Gummidipoondi', 'Kanchipuram', 'Minjur', 'Ponneri',
      'Redhills', 'Sriperumbudur', 'Tindivanam', 'Thiruninravur', 'Thiruthani', 'Thiruvallur', 'Thiruverkadu', 'Tiruvottiyur',
      'Chengalpet', 'Kalpakkam', 'Kandigai', 'Kattupakkam', 'Kelambakkam', 'Kundrathur', 'Mahindra City',
      'Thiruporur', 'Urapakkam', 'Padappai', 'Singaperumal kovil', 'Cuddalore',
      'Coimabatore', 'Madurai'
    ],
    'Andhra Pradesh': ['Tirupati'],
    'Telangana': ['Hyderabad'],
    'Karnataka': ['Bangalore',],
    'Pondicherry': ['Puducherry']
  };

  customerid: any
  deliveryDate: NgbDateStruct;
  hidevalue: number = 0
  checkvalue: number = 0
  minDate: NgbDateStruct;

  billdetail: any = {
    name: '',
    phone: null,
    postalcode: null,
    city: '',
    address: '',
    state: null,
    landmark: '',
    iscurrentaddress: false,
    customerid: null

  }

  OrdCui: number = 0
  ngOnInit(): void {
    this.getcustomerAddressIndex()

    this.billdetail.customerid = localStorage.getItem('customerid');
    this.secid = localStorage.getItem('secid');
    this.OrdCui = parseInt(this.billdetail.customerid, 10) || 0;
  }
  newcustomer: boolean = false
  timeForm: FormGroup;
  // NewCustomer(id) {
  //   // console.log(id)
  //   if (id == 2) {
  //     this.hidevalue = 1
  //     this.checkvalue = id
  //     this.newcustomer = true;
  //   } else {
  //     this.checkvalue = id
  //     // this.getcustomerAddressIndexAll()

  //     this.newcustomer = false;
  //     this.hidevalue = 2
  //     this.checkoutForm.markAsDirty()
  //   }
  // }


  validateAlphabeticInput(event: KeyboardEvent) {
    const keyCode = event.keyCode;
    const allowedKeyCodes = [8, 9, 32];
    if (!((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || allowedKeyCodes.includes(keyCode))) {
      event.preventDefault();
    }
  }

  validateNumericInput(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const inputChar = event.key;

    if (!allowedKeys.includes(inputChar)) {
      event.preventDefault();
    }
  }


  changefilter(bool) {
    this.billdetail.iscurrentaddress = bool
  }

  filteredAddresses = []
  showAddress: boolean = false
  savebill: any = {
    customerid: null
  }

  submitted: boolean = false
  //   SaveAddress() {
  //     console.log(this.billdetail)
  // this.submitted =true
  //     if (this.checkoutForm.invalid) {
  //       this.checkoutForm.markAllAsTouched();
  //       return;
  //     }
  //     // document.getElementById('preloaderaddcus').style.display = 'block'
  //     this.showAddress = true;
  //     this.savebill.name = this.billdetail.name;
  //     this.savebill.phoneno = this.billdetail.phone;
  //     this.savebill.iscurrentaddress = this.billdetail.iscurrentaddress;
  //     this.savebill.customerid = this.customerid;
  //     // this.savebill.address = `${this.billdetail.address}, ${this.billdetail.town} - ${this.billdetail.postalcode}, ${this.billdetail.state} | ${this.billdetail.phone}`;
  //     this.savebill.address = this.billdetail.address,
  //       this.savebill.city = this.billdetail.city,
  //       this.savebill.pincode = this.billdetail.postalcode,
  //       this.savebill.landmark = this.billdetail.landmark,
  //       this.savebill.state = this.billdetail.state,

  // console.log(this.savebill)
  //       this.externalService.SaveCustomerAddress(this.savebill).subscribe(response => {
  //         this.submitted = false;
  //         this.getcustomerAddressIndex();
  //         this.checkoutForm.reset();
  //         this.newcustomer = false;
  //         this.hideCard = false
  //       });

  //   }


  SaveAddress() {
    // console.log(this.savebill)
    // console.log(this.maduraiCityError, this.maduraiDeliveryError)
    if (this.checkoutForm.valid) {
      // console.log('1111111111111')

      if (this.maduraiCityError == false && this.maduraiDeliveryError == false) {
        // console.log('33333333333')

        document.getElementById('preloaderaddcus').style.display = 'block';
        this.savebill = {
          name: this.checkoutForm.controls['name'].value,
          phoneno: this.checkoutForm.controls['phone'].value,
          iscurrentaddress: this.checkoutForm.controls['iscurrentaddress'].value || false,
          address: this.checkoutForm.controls['address'].value,
          city: this.checkoutForm.controls['city'].value,
          pincode: this.checkoutForm.controls['postalcode'].value,
          landmark: this.checkoutForm.controls['landmark'].value,
          state: this.checkoutForm.controls['state'].value,
          customerid: localStorage.getItem('customerid'),

        };
        if (this.cusAddress.length == 0) {
          this.savebill.iscurrentaddress = true
        }

        this.externalService.SaveCustomerAddress(this.savebill).subscribe(
          (response) => {
            if (response["status"] == 200) {
              document.getElementById('preloaderaddcus').style.display = 'none';
              // console.log(response);
              this.submitted = false;
              this.getcustomerAddressIndex();
              this.checkoutForm.reset();
              this.newcustomer = false;
              this.backcard()
              this.toastrService.success('Address Saved successful', 'Success');
            } else {
              document.getElementById('preloaderaddcus').style.display = 'none';
              this.toastrService.error('Address Saved Unsuccessful', 'Error');
            }


          },

        );
      } else {
        // console.log('444444444444')

        this.openErrorModal();
      }
    } else {
      // console.log('222222222')

      Object.keys(this.checkoutForm.controls).forEach((field) => {
        const control = this.checkoutForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }
  custmrid: string = ''
  cities: string[] = [];
  secid: string = ''
  cusAddress: any[] = []
  cartvalue: number = 0
  CusAddId: number = 0

  openErrorModal() {
    this.modalService.open(this.errorModal, { centered: true, size: 'lg' });
  }
  public removeItem(id) {
    // console.log(id)
    document.getElementById('preloadercrt').style.display = 'block'
    this.externalService.DeleteCart(id)
    this.externalService._getCartDel.subscribe(response => {
      this.toastrService.warning('Removed from Cart!', '')

    })
  }

  onStateChange(event: any): void {
    const selectedState = event.target.value;
    // console.log('Selected State:', selectedState);

    // Store the selected state value
    this.billdetail.state = selectedState;

    // Update cities array based on the selected state
    if (this.citiesByState[selectedState]) {
      this.cities = [...this.citiesByState[selectedState]]; // Update cities array
    } else {
      this.cities = [];
    }

    // console.log('Updated Cities:', this.cities); // Debugging: Check updated cities

    // Enable or disable the city control based on the availability of cities
    if (this.cities.length > 0) {
      this.checkoutForm.controls.city.enable();
    } else {
      this.checkoutForm.controls.city.disable();
    }

    // Reset city value (this will ensure that no city is pre-selected if the state changes)
    // this.checkoutForm.controls.city.setValue('');
  }




  getcustomerAddressIndex() {
    document.getElementById('preloaderaddcus').style.display = 'block'
    this.custmrid = localStorage.getItem('customerid')
    this.secid = localStorage.getItem('secid')
    this.externalService.GetCustAddress(this.custmrid, this.secid).subscribe(response => {
      // console.log(response)
      setTimeout(() => {
        document.getElementById('preloaderaddcus').style.display = 'none'
      }, 1300);
      this.cusAddress = response
      if (this.cusAddress.length == 0) {
        this.hidevalue = 1
        this.cartvalue = 1
        this.newcustomer = true
      }
      if (this.cusAddress.length == 1) {
        this.checkvalue = 1
        this.hidevalue = 2
        this.cartvalue = 1
        this.newcustomer = false
      }
      if (this.cusAddress.length > 1) {
        this.checkvalue = 2
        this.hidevalue = 2
        this.cartvalue = 1
        this.newcustomer = false
        this.getcustomerAddressIndexAll()

      }
      this.filteredAddresses = this.cusAddress.filter(address => address.iscurrentaddress);
      this.CusAddId = this.filteredAddresses[0]?.id

    })
  }
  DelCusADDId: number = 0
  getcustomerAddressIndexAll() {
    if (this.DelCusADDId == 0) {
      this.filteredAddresses = this.cusAddress
    } else {
      this.filteredAddresses = this.cusAddress.filter(x => x.id != this.DelCusADDId)
    }
  }

  // Select default customer
  customerId: any
  custaddresid: any
  selectCustomerAddress(customerId, custadresid) {
    this.customerId = customerId
    document.getElementById('preloaderaddcus').style.display = 'block'
    this.custaddresid = custadresid

    this.externalService.SelectCustomerAddress(this.customerId, this.custaddresid).subscribe(response => {

      localStorage.setItem('customeraddressid', this.custaddresid?.toString());
      this.getcustomerAddressIndex()
      this.checkoutForm.reset()
      this.newcustomer = false
      this.hideCard = false
    })

  }

  DelCusId: number = 0

  remove(item) {
    this.DelCusADDId = item.id
    this.DelCusId = item.customerId

    this.modalService.open(this.DeleteModel, { centered: true, size: 'l' });

  }

  DeleteAddress() {
    // document.getElementById('preloaderaddcus').style.display = 'block'
    this.modalService.dismissAll();
    this.externalService.DeleteCustomer(this.DelCusId, this.DelCusADDId)
    this.externalService._getcusDel.subscribe(response => {
      // document.getElementById('preloaderaddcus').style.display = 'none'
      // console.log(response)
      this.getcustomerAddressIndex()
      this.filteredAddresses = this.cusAddress.filter(x => x.id != this.DelCusADDId)
      // console.log(this.filteredAddresses)
      this.toastrService.warning('Address Deleted!', '')
    })
  }

  chrs = 0
  dbool = false
  onDeliveryDateChange(date: NgbDateStruct) {
    // console.log(date)
    if (date) {

      const selectedDate = new Date(date.year, date.month - 1, date.day);
      // console.log("sd: ", selectedDate);
      // console.log("sd: 2", date.day);

      var cday = date.day;

      const now = new Date();
      // console.log(now);
      var day = '' + now.getDate()
      var hrs = '' + now.getHours()
      // console.log("day: ", day);

      // console.log("day: ", hrs);

      if (Number(day) == cday) {
        this.dbool = false;
        // dhrs=
      }
      else {
        this.dbool = true;
      }

      if (selectedDate >= now) {
        this.timeForm.patchValue({ selectedTime: { hour: 10, minute: 0 } });
      } else {
        const now = new Date();
        now.setHours(now.getHours() + 2);
        this.timeForm.patchValue({ selectedTime: { hour: now.getHours(), minute: now.getMinutes() } });
      }
      // console.log(this.timeForm);
    }
  }


  checktime(x) {
    // console.log("x",x);
    // console.log("xdata",this.xdata);
    // console.log("chek time wrks");
    let a: number = this.timeForm.value.selectedTime.hour;
    let b: number = this.timeForm.value.selectedTime.minute;
    // console.log("hrs",a);
    // console.log("mins",b);
    if (a >= 24) {
      // console.log("chek time - Hour greater");
      this.timeForm.value.selectedTime.hour = 1;
    }
    if (b >= 60) {
      //  console.log("chek time - Minute greater");
      this.timeForm.value.selectedTime.minute = 1;
    }
  }

  hideCard: boolean = false

  cardhide() {
    this.EditId = 0
    this.billdetail = {
      name: '',
      phone: null,
      postalcode: null,
      city: '',
      address: '',
      state: null,
      landmark: '',
      iscurrentaddress: false,
      customerid: null
    }
    this.checkoutForm.reset();
    this.hideCard = true
  }

  backcard() {
    this.hideCard = false
  }

  NewCustomer() {
    this.hideCard = false
  }

  EditId = 0
  cusAddId: number = 0
  EditCustomer(item) {
    // console.log(item)
    this.EditId = item.customerId
    this.cusAddId = item.id
    this.checkoutForm.setValue({
      name: item.name,
      phone: item.contact,
      landmark: item.landMark,
      state: item.state,
      postalcode: item.pincode,
      city: item.city,
      address: item.address,
      iscurrentaddress: item.iscurrentaddress,

    });
    this.onStateChange({ target: { value: item.state } });

    this.cities = this.citiesByState[item.state] || [];
    this.changecity({ target: { value: item.city } });


    // this.billdetail = {
    //   name: item.name,
    //   phone: item.contact,
    //   postalcode: item.pincode,
    //   city: item.city,
    //   address: item.address,
    //   state: item.state,
    //   landmark:item.landmark,
    //   iscurrentaddress: item.iscurrentaddress,
    //   customerid: item.customerId,
    //   cusAddId: item.id
    // }
    // console.log(this.billdetail)
    this.hideCard = true
  }

  Updatecustomer() {

    // console.log(this.savebill)
    // console.log(this.maduraiCityError, this.maduraiDeliveryError)
    if (this.checkoutForm.valid) {
      // console.log('1111111111111')

      if (this.maduraiCityError == false && this.maduraiDeliveryError == false) {
        // console.log('33333333333')

        document.getElementById('preloaderaddcus').style.display = 'block';
        this.savebill = {
          name: this.checkoutForm.controls['name'].value,
          phoneno: this.checkoutForm.controls['phone'].value,
          iscurrentaddress: this.checkoutForm.controls['iscurrentaddress'].value,
          address: this.checkoutForm.controls['address'].value,
          city: this.checkoutForm.controls['city'].value,
          pincode: this.checkoutForm.controls['postalcode'].value,
          landmark: this.checkoutForm.controls['landmark'].value,
          state: this.checkoutForm.controls['state'].value,
          custid: localStorage.getItem('customerid'),
          cusAddtId: this.cusAddId,
          ecomOrdId: 0,
          posOrdId: 0
        };
        if (this.cusAddress.length == 0) {
          this.savebill.iscurrentaddress = true
        }
        this.externalService.UpdatecusAdd(this.savebill)
        this.externalService._getUpdateCus.subscribe((response) => {
          // console.log(response);

          if (response["status"] == 200) {
            this.getcustomerAddressIndex();
            this.checkoutForm.reset();
            this.newcustomer = false;
            this.backcard()
            this.toastrService.success('Address Update successful', 'Success');
            document.getElementById('preloaderaddcus').style.display = 'none';
          } else {
            document.getElementById('preloaderaddcus').style.display = 'none';
            this.toastrService.error('Address Update Unsuccessful', 'Error');

          }

        },
        );
      } else {
        // console.log('444444444444')

        this.openErrorModal();
      }
    } else {
      // console.log('222222222')

      Object.keys(this.checkoutForm.controls).forEach((field) => {
        const control = this.checkoutForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }


    // const data = {
    //   custid: this.billdetail.customerid,
    //   cusAddtId: this.billdetail.cusAddId,
    //   name: this.billdetail.name,
    //   // address: this.billdetail.address + this.billdetail.town + '-'+ this.billdetail.postalcode,
    //   address: this.billdetail.address,
    //   city: this.billdetail.city,
    //   pincode: this.billdetail.postalcode,
    //   landmark: this.billdetail.landmark,
    //   state:this.billdetail.state,
    //   phoneno: this.billdetail.phone,
    //   iscurrentaddress: this.billdetail.iscurrentaddress,
    // }
    // // console.log(data)
    // this.externalService.UpdatecusAdd(data)
    // this.externalService._getUpdateCus.subscribe(response => {
    //   // console.log(response)
    //   this.getcustomerAddressIndex()
    //   this.hideCard = false
    //   // this.router.navigate(['/shop/checkout']);
    //   // document.getElementById('preloaderaddcus').style.display = 'none'
    // })
  }
  maduraiDeliveryError: boolean = false;
  maduraiCityError: boolean = false;
  changecity(event) {
    // const selectedState = event.target.value;
    const city = event.target.value; // Get the selected city value
    // console.log(city);

    // Check for specific city conditions (e.g., Madurai)
    if (city === 'Madurai') {
      this.maduraiCityError = true;
      this.maduraiDeliveryError = true;
    } else {
      this.maduraiCityError = false;
      this.maduraiDeliveryError = false;
    }
  }


  phonevalidateNumericInput(event: KeyboardEvent) {
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const inputChar = event.key;
    if (!allowedKeys.includes(inputChar)) {
      event.preventDefault();
    }
  }


  validatePostalCode(): void {
    const postalCode = this.checkoutForm.controls.postalcode.value;
    if (postalCode && !/^\d{6}$/.test(postalCode)) {
      alert('Please enter a valid 6-digit postal code');
    }
  }


  onSubmit() {
    if (this.EditId === 0) {
      this.SaveAddress();
    } else {
      this.Updatecustomer();
    }
  }

}
